module.exports = __webpack_public_path__ + "img/arch-high.fe437215.svg";